import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../config/apiConfig';
import { buildWhatsAppUrl, CONTACT } from '../../config/contact';

const FOOTER_SERVICES: Array<{ slug: string; label: string }> = [
  { slug: 'agriculture', label: 'Agriculture' },
  { slug: 'weddings-events', label: 'Weddings & Events' },
  { slug: 'real-estate', label: 'Real Estate' },
  { slug: 'construction', label: 'Construction' },
  { slug: 'solar-inspection', label: 'Solar Inspection' },
  { slug: 'mining', label: 'Mining' },
  { slug: 'government-survey', label: 'Government Survey' },
  { slug: 'disaster-response', label: 'Disaster Response' },
];

const FOOTER_CITIES: Array<{ slug: string; label: string }> = [
  { slug: 'mumbai', label: 'Mumbai' },
  { slug: 'delhi-ncr', label: 'Delhi NCR' },
  { slug: 'bengaluru', label: 'Bengaluru' },
  { slug: 'hyderabad', label: 'Hyderabad' },
  { slug: 'pune', label: 'Pune' },
  { slug: 'jaipur', label: 'Jaipur' },
  { slug: 'ahmedabad', label: 'Ahmedabad' },
  { slug: 'chennai', label: 'Chennai' },
  { slug: 'kolkata', label: 'Kolkata' },
  { slug: 'kochi', label: 'Kochi' },
];

export const PublicFooter = () => (
  <footer className="mt-10 border-t border-slate-200 bg-[#04102e] text-slate-200">
    <div className="World-flag-stripe h-1 w-full" />
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-10 md:grid-cols-6">
      <div className="md:col-span-2">
        <Link to="/" className="flex items-center gap-2">
          <span aria-hidden className="flex h-6 w-6 overflow-hidden rounded">
            <span className="h-full w-1/3 bg-[#FF9933]" />
            <span className="h-full w-1/3 bg-white" />
            <span className="h-full w-1/3 bg-[#138808]" />
          </span>
          <span className="text-2xl font-black text-white">AeroBott</span>
        </Link>
        <p className="mt-3 text-base font-bold World-gold-text">India's verified drone pilot marketplace</p>
        <p className="mt-3 max-w-xs text-sm text-slate-300">
          Connecting Indian businesses with verified drone pilots for safe, compliant, premium aerial imaging.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <span className="rounded-full bg-[#138808]/15 px-3 py-1 text-xs font-bold text-[#9be39b]">Verified pilots</span>
          <span className="rounded-full bg-[#FF9933]/15 px-3 py-1 text-xs font-bold text-[#ffd6a5]">Secure escrow</span>
          <span className="rounded-full border border-white/20 px-3 py-1 text-xs font-black World-gold-text">Make in India</span>
        </div>

        <div className="mt-6">
          <p className="text-xs font-black uppercase tracking-wide text-slate-400">Get in touch</p>
          <ul className="mt-3 grid gap-2 text-sm">
            <li>
              <a href={buildWhatsAppUrl('Hi AeroBott — I have a question.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#25D366] hover:underline">
                <span aria-hidden>💬</span> WhatsApp {CONTACT.whatsappDisplay}
              </a>
            </li>
            <li>
              <a href={`tel:+${CONTACT.whatsappNumber}`} className="inline-flex items-center gap-2 hover:text-[#FF9933]">
                <span aria-hidden>📞</span> +{CONTACT.whatsappDisplay.replace(/^\+/, '')}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 hover:text-[#FF9933]">
                <span aria-hidden>✉️</span> {CONTACT.email}
              </a>
            </li>
            <li className="text-xs text-slate-400">Support hours: Mon–Sat, 10:00–19:00 IST</li>
          </ul>
        </div>
      </div>

      <div>
        <p className="text-xs font-black uppercase tracking-wide text-slate-400">Resources</p>
        <ul className="mt-3 grid gap-2 text-sm">
          <li><Link to="/how-it-works" className="hover:text-[#FF9933]">How it Works</Link></li>
          <li><Link to="/register-pilot" className="hover:text-[#FF9933]">Become a Pilot</Link></li>
          <li><Link to="/done-for-you" className="hover:text-[#FF9933]">Done For You</Link></li>
          <li><Link to="/pilots/map" className="hover:text-[#FF9933]">Map View</Link></li>
          <li><Link to="/portfolio-reels" className="hover:text-[#FF9933]">Portfolio Reels</Link></li>
          <li><Link to="/faqs/client" className="hover:text-[#FF9933]">Client FAQs</Link></li>
          <li><Link to="/faqs/pilot" className="hover:text-[#FF9933]">Pilot FAQs</Link></li>
        </ul>
      </div>

      <div>
        <p className="text-xs font-black uppercase tracking-wide text-slate-400">Services</p>
        <ul className="mt-3 grid gap-2 text-sm">
          {FOOTER_SERVICES.map((s) => (
            <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-[#FF9933]">{s.label}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs font-black uppercase tracking-wide text-slate-400">Cities</p>
        <ul className="mt-3 grid gap-2 text-sm">
          {FOOTER_CITIES.map((c) => (
            <li key={c.slug}><Link to={`/locations/${c.slug}`} className="hover:text-[#FF9933]">{c.label}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs font-black uppercase tracking-wide text-slate-400">Legal</p>
        <ul className="mt-3 grid gap-2 text-sm">
          <li><Link to="/privacy-policy" className="hover:text-[#FF9933]">Privacy Policy</Link></li>
          <li><Link to="/terms/client" className="hover:text-[#FF9933]">Client Terms</Link></li>
          <li><Link to="/terms/pilot" className="hover:text-[#FF9933]">Pilot Terms</Link></li>
          <li><Link to="/refund-policy" className="hover:text-[#FF9933]">Refund Policy</Link></li>
        </ul>

        <p className="mt-6 text-xs font-black uppercase tracking-wide text-slate-400">Developers</p>
        <ul className="mt-3 grid gap-2 text-sm">
          <li>
            <a
              href={`${API_BASE_URL}/docs`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FF9933]"
            >
              API Docs (Swagger) ↗
            </a>
          </li>
          <li>
            <a
              href={`${API_BASE_URL}/redoc`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FF9933]"
            >
              ReDoc ↗
            </a>
          </li>
          <li>
            <a
              href={`${API_BASE_URL}/openapi.json`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FF9933]"
            >
              OpenAPI JSON ↗
            </a>
          </li>
          <li>
            <a href={`${API_BASE_URL}/health`} target="_blank" rel="noopener noreferrer" className="hover:text-[#FF9933]">
              API status ↗
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 bg-[#020824] px-5 py-4 text-center text-xs text-slate-400">
      &copy; {new Date().getFullYear()} AeroBott · <span className="World-gold-text">India Drone Mission 🇮🇳</span> · India's verified drone pilot marketplace.
    </div>
  </footer>
);
